module.exports = __webpack_public_path__ + "img/poster.3e7ef9e1.png";